<template>
    <div id="notification-intro" :class="isNight ? 'night' : ''">
        <h1>为何要添加通知中心行情？</h1>
        <p>在手机通知中心添加 <span>“金果子-行情”</span> 小组件，可以在手机上快速浏览你关注的行情信息。</p>
        <div class="img-box">
            <img class="mgr60" src="@/assets/notification/left.png" alt="">
            <img src="@/assets/notification/right.png" alt="">
            <img class="arrow" src="@/assets/notification/arrow.png" alt="">
        </div>
        <div class="tip">手机桌面滑到最左，可直接查看所关注行情</div>
        <h1>如何添加金果子组件？</h1>
        <p>在通知中心页面找到底部“编辑”，点击后添加 <span>“金果子-行情”</span> 即可。</p>
        <div class="img-box">
            <img class="mgr60" src="@/assets/notification/left1.png" alt="">
            <img src="@/assets/notification/right1.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationIntro',
    data() {
        return {
            isNight: false
        }
    },
    mounted() {
        this.isNight = this.$route.query ? (this.$route.query.theme === 'night' ? true : false) : false;
    }
}
</script>

<style lang='less'>
#notification-intro {
    width: 100%;
    height: auto;
    position: relative;
    padding: 70px 50px 60px 50px;
    background: #FFFFFF;
    text-align: left;
    &.night {
        background: #181820;
        h1, p {
            color: #E3E3E1;
        }
        
    }
    h1 {
        font-size: 34px;
        font-weight: bold;
        color: #33333A;
        margin-bottom: 20px;
    }
    p {
        font-size: 30px;
        color: #33333A;
        line-height: 45px;
        margin-bottom: 30px;
        span {
            color: #FFA41F;
        }
    }
    .img-box {
        position: relative;
        text-align: center;
        margin-bottom: 20px;
        img {
            height: 498px;
            width: 280px;
        }
        .mgr60 {
            margin-right: 60px;
        }
        .arrow {
            height: 60px;
            width: 124px;
            position: absolute;
            top: 192px;
            left: 50%;
            transform: translateX(-62px);
        }
    }
    .tip {
        font-size: 24px;
        text-align: center;
        margin-bottom: 40px;
        color: #FFA41F;
    }
}
</style>
